export { default as Main } from './Main';
export { default as Detail } from './Detail';
